<template>
  <div class="file-menu">
    <van-nav-bar fixed placeholder title left-arrow right-text="搜索" left-text="返回"
                 @click-left="$router.go(-1)"
                 @click-right="onSearch">
      <template #title>
        <van-search clearable shape="round" v-model="keyword" placeholder="此版块内的关键词搜索"/>
      </template>
      <template #right></template>
    </van-nav-bar>
    <div class="scrolly">
      <!--      <dd-cell v-for="info in currentItemList" :key="info.name" :item="info" @click="itemClick"></dd-cell>-->
      <van-list style="padding-bottom:100px" v-model="loading" :finished="finished" finished-text @load="onLoad">
        <van-cell title-style="text-align:left;" class="iconfont"
                  v-for="info in currentList" :key="info.id"
                  :title="info.title" icon-prefix="icon" :is-link="true"
                  icon="wenjian"
                  :label="global.formatDate(info.createTime,'yyyy-MM-dd')"
                  @click="itemClick(info)"/>
      </van-list>
    </div>
  </div>
</template>

<script>
import {Dialog} from 'vant';
import {
  Get_Brand_Node_List,
  Get_File_Node_List,
  Get_Case_List
  // Is_Today_FileViewNum_OverLimit
} from "@/api/index";
import {
  NavBar,
  Search,
  Image as VanImage,
  Icon,
  List,
  PullRefresh,
  Cell,
  CellGroup,
  Toast,
} from "vant";

export default {
  name: "CaseList",
  components: {
    [NavBar.name]: NavBar,
    [Search.name]: Search,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Icon.name]: Icon,
    [VanImage.name]: VanImage,
    [Toast.name]: Toast,
  },
  data() {
    return {
      title: '',
      carModeId: 0,
      current: 0,
      list: [],
      loading: false,
      page: 1,
      finished: false,
      refreshing: false,
      keyword: "",
      currentList: [],
      tabs: [],
      historyList: [],
      brandId: 0,
      isVip: false,
    };
  },
  computed: {
    currentItemList() {
      return this.currentList.map(v => {
        v.icon = !v.filePath ? 'list-dot' : (v.filePath.indexOf('.pdf') > 0 ? 'file-text' : 'list-dot')
        return v;
      })
    }
  },
  mounted() {
    // this.getBrandNodeList();
    this.brandId = this.$route.query.brandId
    // this.getBrandNode();
    this.loading = false;
    this.finished = true;

    if (this.$route.query.title) {
      document.title = this.$route.query.title
    }
    this.getFileNodeList()
  },

  methods: {
    async onSearch() {
      if (!this.keyword) {
        Toast("请输入关键词");
        return;
      }
      //添加回退记录
      this.historyList.push(this.currentList);
      this.currentList = []
      await this.getFileNodeList()
    },
    onLoad(options) {


    },
    async getFileNodeList(id) {
      Get_Case_List({
        memberId: 0,
        brandId: this.brandId,
        isPass: 1,
        searchKey: this.keyword,
        // type: this.$route.query.type,
        // searchKey: this.filter.key,
        // startDate: this.filter.startDate,
        // endDate: this.filter.endDate,
        pageSize: 20,
        page: this.page,
      }).then((data) => {
        this.finished = data.length < 20;
        this.currentList = this.currentList.concat(data);
        this.page++;
        this.loading = false;
      });
    },
    onClickLeft() {
      console.log(this.historyList)
      // return
      if (this.historyList.length >= 1) {
        this.currentList = this.historyList.pop();
      } else {
        this.$router.back()
      }
    },
    itemClick(info) {
      info.brandId = this.brandId;
      info.type = 'case'
      sessionStorage.setItem("fileNode", JSON.stringify(info));
      this.playCase()
    },
    playCase() {
      const user = JSON.parse(localStorage.getItem('User'))

      if (new Date(user.endDate) < new Date()) {
        this.isVip = false
        Dialog({message: '案例只有未过期会员才可读取！'});
      } else {
        this.isVip = true
        // Is_Today_FileViewNum_OverLimit({ //统一在获取URL时检查即可
        //   type: 1
        // }).then((n) => {
        //   if (!n) {
        this.$router.push({path: "/fileshow"});
        //   } else {
        //     Dialog({ message: '你太好学了，稍微歇一歇，明天继续看吧' });
        //   }
        // });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.file-menu {
  height: 100vh;

  .scrolly {
    height: calc(100vh - 50px);
    overflow-y: auto;
  }
}

.file-header {
  font-size: 14px;
  padding: 8px;
  width: calc(100% - 66px);
}

.flex {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.tab-content {
  margin-top: 1px;
  height: calc(100vh - 180px);
}

.footer {
  position: fixed;
  bottom: 60 rpx;
  width: 100vw;
  padding: 20 rpx;
  height: 48px;
}
</style>
